import {TSSerializable} from './TSSerializable';

export default class TSPasswordData implements TSSerializable<TSPasswordData> {

    private _password?: string;
    private _passwordRepeat?: string;
    private _email?: string;
    private _resetToken?: string;

    constructor(email: string, resetToken?: string) {
        this._email = email;
        this._resetToken = resetToken;
    }

    public get password(): string | undefined {
        return this._password;
    }

    public set password(value: string| undefined) {
        this._password = value;
    }

    public get passwordRepeat(): string| undefined {
        return this._passwordRepeat;
    }

    public set passwordRepeat(value: string| undefined) {
        this._passwordRepeat = value;
    }

    public get email(): string | undefined {
        return this._email;
    }

    public set email(value: string | undefined) {
        this._email = value;
    }

    public get resetToken(): string| undefined {
        return this._resetToken;
    }

    public set resetToken(value: string | undefined) {
        this._resetToken = value;
    }

    public serialize(restObject: any): any {

        restObject.email = this.email;
        restObject.resetToken = this.resetToken;
        restObject.password = this.password;
        restObject.passwordRepeat = this.passwordRepeat;
        return restObject;
    }

    public deserialize(restObject: any): TSPasswordData {
        this._resetToken = restObject.resetToken;
        this._password = restObject.password;
        this._passwordRepeat = restObject.passwordRepeat;
        this._email = restObject.email;

        return this;
    }
}



// WEBPACK FOOTER //
// ./src/app/models/TSPasswordData.ts